import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import SingleSelectButton from '../SingleSelectButton/SingleSelectButton.js';
import SingleSelectMenu from '../SingleSelectMenu/SingleSelectMenu.js';
import styles from './SingleSelect.scss.js';
import useClickOutside from '../../Hooks/useClickOutside/useClickOutside.js';
import { sizeOptions } from '../../../../helpers/enums/themes/sizeOptions.js';

const SingleSelect = _ref => {
  let {
    isDisabled,
    isGrid,
    options,
    value,
    onSelect,
    isFullWidth,
    borderColor,
    hideMenuInnerBorder,
    maxHeightValue,
    placeholder,
    size = sizeOptions.medium,
    menuPosition = 'bottom'
  } = _ref;
  const wrapperRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const handleToggle = () => {
    setIsOpen(!isOpen);
  };
  const onClose = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };
  const onOptionSelected = selectedType => {
    const selectedElement = options.find(element => element.type === selectedType);
    onSelect(selectedElement);
    onClose();
  };
  useClickOutside(wrapperRef, onClose);
  return /*#__PURE__*/React.createElement("div", {
    ref: wrapperRef,
    className: classNames(styles.wrapper, {
      [styles['wrapper--full-width']]: isFullWidth
    })
  }, /*#__PURE__*/React.createElement(SingleSelectButton, {
    icon: "select-dropdown",
    isFullWidth: isFullWidth,
    isDisabled: isDisabled,
    selected: value,
    placeholder: placeholder,
    isOpen: isOpen,
    onSelect: handleToggle,
    borderColor: borderColor,
    size: size
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.menu, styles[`menu--position-${menuPosition}`], {
      [styles['menu--full-width']]: isFullWidth
    })
  }, /*#__PURE__*/React.createElement(SingleSelectMenu, {
    options: options,
    isOpen: isOpen,
    hideInnerBorder: hideMenuInnerBorder,
    isGrid: isGrid,
    onSelect: onOptionSelected,
    maxHeightValue: maxHeightValue
  })));
};
var SingleSelect$1 = SingleSelect;

export { SingleSelect$1 as default };
//# sourceMappingURL=SingleSelect.js.map
